import { useState } from 'react';

import StartPageButton from '../components/StartPageButton';
import MultipartForm from '../components/MultipartForm/MultipartForm';
import Step1 from '../components/ApplicationForm/Step1';
import Step2 from '../components/ApplicationForm/Step2';
import Step3 from '../components/ApplicationForm/Step3';
import ReviewStep from '../components/ApplicationForm/ReviewStep';
import jumpToTop from '../util/jumpToTop';

import needIdeaImg from '../assets/application-start/application-need-idea-500.png';
import haveIdeaImg from '../assets/application-start/application-have-idea-500.png';
import CTA from '../components/MultipartForm/CTA';

const noop = () => {};

const App = () => {

  // If we show the "Let's get started" screen or not
  const [started, setStarted] = useState(false);

  const steps = [
    // NOTE: these noop functions get replaced in MultipartForm
    <Step1 label="About you" goToStep={noop} returnToStep={noop} next={noop} prev={noop} reviewMode={false} />,
    <Step2 label="Project supporter" goToStep={noop} returnToStep={noop} next={noop} prev={noop} reviewMode={false} />,
    <Step3 label="Your idea" goToStep={noop} returnToStep={noop} next={noop} prev={noop} reviewMode={false} />,
  ];

  // Add review steps with reference to existing steps
  const stepsWithReview = [
    ...steps,
    <ReviewStep goToStep={noop} returnToStep={noop} steps={steps} label="Review" next={noop} prev={noop} reviewMode={true} />
  ];

  return (
    <div className="App">
      {
        started
        ? // The actual form
          <MultipartForm
            stepComponents={ stepsWithReview }
            doneScreenContent={(
              <CTA
                background="pink"
                heading="We've received your application."
              >
                <p>Check your email for next steps!</p>
                <a href="/">Return to Home page</a>
              </CTA>
            )}
          />
        : ( // The pre-form "let's get started" intro screen
          <div className="Application_Start_Page">
            <div className="Application_Start_Banner row">
              <div className="col-xs-12 col-md-6 Application_Start_Banner__block Application_Start_Banner__block--1">
                <h3 className="Application_Start_Banner__Heading Application_Start_Banner__Heading--big">Try something new with help from the Youth Creativity Fund!</h3>
                <p>Our goal is to fund as many ideas as possible that meet this criteria:</p>
              </div>
              <div className="col-xs-12 col-md-3 Application_Start_Banner__block Application_Start_Banner__block--2">
                <h3 className="Application_Start_Banner__Heading">Applicants must:</h3>
                <ul>
                  <li>Be within 15 - 18 years old</li>
                  <li>Be attending school in Waterloo Region</li>
                  <li>Agree to share your learning within 3 months of acceptance</li>
                  <li>Have a “project advisor” who will supervise their activities and receive the grant on their behalf, if under 18 years old</li>
                  <li>Agree to other terms as outlined in participant forms for those <a href="/forms/participant-under-18" target="_blank">under 18</a> or <a href="/forms/participant-over-18" target="_blank">18+</a></li>
                </ul>
              </div>
              <div className="col-xs-12 col-md-3 Application_Start_Banner__block Application_Start_Banner__block--3">
                <h3 className="Application_Start_Banner__Heading">Projects must:</h3>
                <ul>
                  <li>Have the goal of solving a problem and learning from the experience, rather than personal financial benefit</li>
                  <li>Be socially and environmentally responsible: we will not fund ideas that create environmental or physical harm, or discriminate against people based on who they are, what they look like, or where they were born </li>
                  <li>Follow current public health guidelines</li>
                  <li>Include a detailed budget and timeline</li>
                </ul>
              </div>
            </div>
            <h3 className="Form__heading">Let’s get started!</h3>
            <div className="Application_Start_Options">
              <StartPageButton
                imgUrl={haveIdeaImg}
                text="I have a creative idea"
                onClick={() => {
                  setStarted(true);
                  jumpToTop();
                }}
              />
              <span className="Application_Start_Options__or">OR</span>
              <StartPageButton
                imgUrl={needIdeaImg}
                text="I need help with an idea"
                // TODO: is navigating with js fine?
                // TODO: put in actual URL
                // onClick={() => window.location.href = '/toolbox#available-resources'}
                onClick={() => window.open('/toolbox#available-resources', '_blank')}
              />
            </div>
          </div>
        )
      }

    </div>
  );
}

export default App;
